import { render, staticRenderFns } from "./subSupplierDialog.vue?vue&type=template&id=1052420d&scoped=true"
import script from "./subSupplierDialog.vue?vue&type=script&lang=js"
export * from "./subSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052420d",
  null
  
)

export default component.exports